export const EmployeePaymentModes = {
  FixedSalaryOnly: 0,
  CommissionOnly: 1,
  Mixed: 2,
  CommissionWithMinimum: 3,
};

export const EmployeePayCadence = {
  Monthly: 0,
  Weekly: 1,
};

export const PAY_DAY_MIN = 1;
export const PAY_DAY_MAX = 28;
export const PAY_DAY_DEFAULT = 1;

export const WEEKDAY_OPTIONS = [
  { value: 1, key: 'monday' },
  { value: 2, key: 'tuesday' },
  { value: 3, key: 'wednesday' },
  { value: 4, key: 'thursday' },
  { value: 5, key: 'friday' },
  { value: 6, key: 'saturday' },
  { value: 0, key: 'sunday' },
];

export const normalizePaymentMode = (mode) => {
  if (mode == null) {
    return EmployeePaymentModes.CommissionOnly;
  }

  if (typeof mode === 'number' && mode >= 0 && mode <= 3) {
    return mode;
  }

  const normalized = String(mode).replace(/\s+/g, '').toLowerCase();
  if (normalized === 'fixedsalaryonly' || normalized === '0') return EmployeePaymentModes.FixedSalaryOnly;
  if (normalized === 'commissiononly' || normalized === '1') return EmployeePaymentModes.CommissionOnly;
  if (normalized === 'mixed' || normalized === '2') return EmployeePaymentModes.Mixed;
  if (normalized === 'commissionwithminimum' || normalized === '3') return EmployeePaymentModes.CommissionWithMinimum;

  return EmployeePaymentModes.CommissionOnly;
};

export const normalizePayCadence = (cadence) => {
  if (cadence == null) {
    return EmployeePayCadence.Monthly;
  }

  if (typeof cadence === 'number' && (cadence === 0 || cadence === 1)) {
    return cadence;
  }

  const normalized = String(cadence).replace(/\s+/g, '').toLowerCase();
  if (normalized === 'weekly' || normalized === '1') return EmployeePayCadence.Weekly;
  return EmployeePayCadence.Monthly;
};

export const getPaymentModeKey = (mode) => {
  switch (normalizePaymentMode(mode)) {
    case EmployeePaymentModes.FixedSalaryOnly:
      return 'fixedSalaryOnly';
    case EmployeePaymentModes.CommissionOnly:
      return 'commissionOnly';
    case EmployeePaymentModes.Mixed:
      return 'mixed';
    case EmployeePaymentModes.CommissionWithMinimum:
      return 'commissionWithMinimum';
    default:
      return 'unknown';
  }
};

export const getPayCadenceKey = (cadence) => (
  normalizePayCadence(cadence) === EmployeePayCadence.Weekly ? 'weekly' : 'monthly'
);

export default EmployeePaymentModes;
